import React, { Component } from 'react';
import { View, Text } from 'react-native';
import utils from '../utils';
import { enabledStyle, disabledStyle } from '../commonStyles';

const titleMap: { [propName: string]: string } = {
    4001001: '度假-跟团游',
    4001002: '度假-自由行',
    4001003: '度假-签证',
    4001004: '度假-邮轮',
    4001006: '度假-自定义'
};

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning'
};

const appActionMap: { [propName: string]: boolean } = {
    pay: true
};

interface Props {
    data: {
        productTitle: string;
        sysCode: number;
        orderType: string;
        handleTime: string;
        destination: string;
        startTime: string;
        endTime: string;
        days: number;
        productContain: string;
        visaInfo: string;
        fixPrice: string;
        depositPriceInfo: string;
        fullPriceInfo: string;
        fromDate: string;
        toDate: string;
        productType: string;
        roomType: string;
        showTime: string;
        bookCount: string;
        maleCount: number;
        femaleCount: number;
        voucherCount: number;
        voucherMoneyInfo: string;
        reachPeopleCount: number;
        lessPeopleCount: number;
        peopleCount: number;
        comment: string;
        _disable: boolean;
    };
}

class Index extends Component<Props> {
    public static formatData(data: any) {
        const newData = { ...data };
        // icon
        newData.iconfont = '\uf1e5';
        newData.iconColor = '#1bc366';

        // 微导游 特殊icon，右箭头
        if (newData.orderType === 4007001) {
            newData.iconfont = '\ue0b9';
            newData.statusDesc = '\uf03e';
            newData.showRightArrow = true;
            newData.title = newData.businessTitle
                ? `${newData.businessTitle}-免费微导游`
                : newData.title;
        }

        // title
        if (newData.sysCode === 4001) {
            newData.title = titleMap[newData.orderType] ? titleMap[newData.orderType] : '度假';
        } else if (newData.sysCode === 4003) {
            newData.title = '度假-景酒自由行';
        } else if (newData.sysCode === 4008) {
            newData.title = '度假-交通+酒店自由行';
        } else if (newData.sysCode === 4009) {
            newData.title = '度假-跟团游';
        } else if (newData.sysCode === 4010) {
            newData.title = '度假-密室';
        } else if (newData.sysCode === 4011) {
            newData.title = '度假-定制游';
        }
        // 状态
        newData._orderStatus = statusMap[newData.status];
        // 按钮
        newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);

        newData.visaInfo =
            (newData.visaCount ? `${newData.visaCount}份  ` : '') +
            (newData.visaTag ? newData.visaTag : '');

        if (newData.payDeadline) {
            newData.deadlineNotice = `请于${newData.payDeadline}前完成支付`;
        }

        // 价格
        newData.isCommonPriceTpl = false;
        newData.fixPrice = utils.fixPrice(newData.price);
        newData.depositPriceInfo = utils.fixPrice(newData.depositPrice);
        newData.fullPriceInfo = utils.fixPrice(newData.fullPrice);
        newData.voucherMoneyInfo = utils.fixPrice(newData.voucherMoney);

        return newData;
    }

    public render() {
        const {
            data: {
                productTitle,
                sysCode,
                orderType,
                handleTime,
                destination,
                startTime,
                endTime,
                days,
                productContain,
                visaInfo,
                fixPrice,
                depositPriceInfo,
                fullPriceInfo,
                fromDate,
                toDate,
                productType,
                roomType,
                showTime,
                bookCount,
                maleCount,
                femaleCount,
                voucherCount,
                voucherMoneyInfo = 0,
                reachPeopleCount,
                lessPeopleCount,
                peopleCount,
                comment,
                _disable
            } = {}
        } = this.props;
        const styles = _disable ? disabledStyle : enabledStyle;

        return (
            <View style={styles.contentWrapper}>
                <View style={styles.left}>
                    <Text style={styles.newOrderTitle} numberOfLines={2}>
                        {productTitle}
                    </Text>
                    {Boolean(sysCode === 4011 && orderType === 4011001) && (
                        <View>
                            <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                {`目的地      ${destination}`}
                            </Text>
                            {Boolean(startTime && endTime) && (
                                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                    {`出发日期  ${startTime} 至 ${endTime}`}
                                </Text>
                            )}
                            {Boolean(days) && (
                                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                    {`行程天数  ${days}天`}
                                </Text>
                            )}
                            {Boolean(productContain) && (
                                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                    {`出行人数  ${productContain}`}
                                </Text>
                            )}
                        </View>
                    )}
                    {Boolean(sysCode === 4001) &&
                        (orderType === 4001003 ? (
                            <View>
                                {Boolean(handleTime) && (
                                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                        {`办理时间  ${handleTime}`}
                                    </Text>
                                )}
                                {Boolean(visaInfo) && (
                                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                        {visaInfo}
                                    </Text>
                                )}
                            </View>
                        ) : orderType !== 4001006 ? (
                            <View>
                                {Boolean(startTime) && (
                                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                        {`出发时间  ${startTime}`}
                                    </Text>
                                )}
                                {Boolean(fromDate && toDate) && (
                                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                        {`有效时间  ${fromDate} 至 ${toDate}`}
                                    </Text>
                                )}
                                {Boolean(productType) && (
                                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                        {`产品类型  ${productType}`}
                                    </Text>
                                )}
                                {Boolean(days) && (
                                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                        {`行程天数  ${days}`}
                                    </Text>
                                )}
                                {Boolean(productContain) && (
                                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                        {`套餐包含  ${productContain}`}
                                    </Text>
                                )}
                            </View>
                        ) : null)}
                    {Boolean(sysCode === 4003 || sysCode === 4008 || sysCode === 4009) && (
                        <View>
                            {Boolean(startTime) && (
                                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                    {`出发时间  ${startTime}`}
                                </Text>
                            )}
                            {Boolean(days) && (
                                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                    {`行程天数  ${days}`}
                                </Text>
                            )}
                            {Boolean(productContain) && (
                                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                    {`套餐包含  ${productContain}`}
                                </Text>
                            )}
                            {Boolean(roomType) && (
                                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                    {`房型信息  ${roomType}`}
                                </Text>
                            )}
                        </View>
                    )}
                    {Boolean(sysCode === 4010) && (
                        <View>
                            <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                {`场次时间  ${showTime}`}
                            </Text>
                            {Boolean(bookCount) && (
                                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                    {`预订人数  ${bookCount}人   ${maleCount}男+${femaleCount}女`}
                                </Text>
                            )}
                            {Boolean(voucherCount) && (
                                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                    {`用券数量  ${voucherCount}张  （抵用金额：￥${voucherMoneyInfo})`}
                                </Text>
                            )}
                            {Boolean(lessPeopleCount) && (
                                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                    {`成场人数: ${reachPeopleCount}人   还差${lessPeopleCount}人可成场`}
                                </Text>
                            )}
                            {Boolean(peopleCount) && (
                                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                    {`退款人数  ${peopleCount}人`}
                                </Text>
                            )}
                        </View>
                    )}
                    {Boolean(sysCode === 4007 && orderType === 4007001) && (
                        <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                            {comment}
                        </Text>
                    )}
                </View>
                <View style={styles.right}>
                    {Boolean(fixPrice) && (
                        <Text style={styles.orderPriceWrapper} numberOfLines={1}>
                            <Text style={styles.orderPriceCurrency}>&yen;</Text>
                            <Text style={styles.orderPrice}>{` ${fixPrice}`}</Text>
                        </Text>
                    )}
                    {Boolean(depositPriceInfo) && (
                        <Text
                            style={[styles.orderPriceWrapper, styles.orderPriceConvert]}
                            numberOfLines={1}
                        >
                            定金&yen;
                            {depositPriceInfo}
                        </Text>
                    )}
                    {Boolean(fullPriceInfo) && (
                        <Text
                            style={[styles.orderPriceWrapper, styles.orderPriceConvert]}
                            numberOfLines={1}
                        >
                            全款&yen;
                            {fullPriceInfo}
                        </Text>
                    )}
                </View>
            </View>
        );
    }
}

export default Index;
